<div class="display">
    <header>
        <img class="brand" src="assets/images/logo-branco.png">
    </header>
    <div *ngIf="!onlineOffline" class="offline">
        <span><mat-icon class="offline--icon">wifi_off</mat-icon>Você esta sem conexão com a internet no momento.</span>
    </div>
</div>